<template>
  <svg width="16"
       height="16"
       viewBox="0 0 16 16"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path d="M7.33301 11.6666V8.66659H1.33301V7.33325H7.33301V4.33325H14.6663V11.6666H7.33301Z" :fill="color" />
  </svg>
</template>
<script>
export default {
  props: {
    color: {
      type: String,
      default: "#CC4F4F"
    }
  }
}
</script>
